import { Component } from '@angular/core';
import { BreadcrumbService } from '@library/core/services';

@Component({
   selector: 'lib-terms-view',
   template: `
   <div  class="common-pad1em">
      <h2 color="primary">{{portal | uppercase}}</h2>

      <h2 color="primary">TERMS OF USE</h2>
      <lib-terms></lib-terms>

      <div class="common-h2em"></div>

      <h2 color="primary">TERMS AND CONDITIONS</h2>
      <lib-conditions></lib-conditions>
   </div>`,
})
export class TermsViewComponent {
   portal = document.title;

   constructor(
      private breadcrumbs: BreadcrumbService,
   ) {
      this.breadcrumbs.newCrumb({ label: 'Terms', path: '/terms' });
   }
}
